import { Container } from 'reactstrap';
import { StudentRiskPrimaryFiltersLoader } from './parts/StudentRiskHistory/hooks/StudentRiskFiltersLoader';
import { StudentListContainer } from './parts/StudentRiskHistory/StudentListContainer';

export function StudentRiskHistory() {
  return (
    <div className="w-100 mt-4 d-flex flex-wrap justify-content-center">
      <StudentRiskPrimaryFiltersLoader fetchImmediately>
        <Container fluid>
          <StudentListContainer />
        </Container>
      </StudentRiskPrimaryFiltersLoader>
    </div>
  );
}
